import { CSSProperties } from "react";
import { Icon } from "../Icon";
import styles from "./Checkbox.module.scss";

type CheckboxProps = {
  id?: string;
  checkboxId?: string;
  onClick?: (e: React.MouseEvent) => void;
  onChange?: (newValue: boolean) => void;
  nativeOnChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: React.FocusEventHandler;
  required?: boolean;
  checked?: boolean;
  label: string | React.ReactElement;
  hideLabel?: boolean;
  dark?: boolean;
  className?: string;
  style?: {
    container?: CSSProperties;
    checkbox?: CSSProperties;
  };
  disabled?: boolean;
  "aria-describedby"?: string;
};

export function Checkbox({
  id,
  checkboxId,
  onClick,
  onChange,
  nativeOnChange,
  onBlur,
  checked,
  label,
  required,
  hideLabel,
  dark,
  className,
  style,
  disabled,
  "aria-describedby": ariaDescribedBy,
}: CheckboxProps) {
  return (
    <label
      id={id}
      className={`${styles.checkboxContainer} ${dark && styles.dark} ${disabled && styles.disabled} ${className}`}
      onClick={(e) => !!onClick && onClick(e)}
      style={style?.container}
    >
      <span className={hideLabel ? "sr-only" : ""}>
        <>{label}</>
      </span>
      <input
        required={required}
        type="checkbox"
        disabled={disabled}
        aria-describedby={ariaDescribedBy}
        checked={checked}
        onBlur={onBlur}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          if (onChange) onChange(e.target.checked);
          if (nativeOnChange) nativeOnChange(e);
        }}
      />
      <span
        id={checkboxId}
        className={styles.customCheckbox}
        style={style?.checkbox}
      >
        <Icon name="done" className={styles.checkIcon} aria-hidden />
      </span>
    </label>
  );
}
